import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { AmSliderPointsModule } from '@am/am-alliances-slider';
import { AmRewardsPricingModule } from '@am/rewards-pricing';
import { SharedModule } from '@shared/shared.module';
import { ResultsMobileRoutingModule } from './results-mobile-routing.module';
import { ResultsMobileComponent } from './results-mobile.component';
import { FormsModule } from '@angular/forms';
import { HotelsService } from '@core/services/hotels.service';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CheckPipe } from '@shared/pipes/check.pipe';

import * as fromResults from '@results/store';
import { ResultsEffecs } from '@results/store/results.effects';
import { MbButtonModule } from '@am/moebius';

@NgModule({
  declarations: [ResultsMobileComponent],
  imports: [
    CommonModule,
    OverlayModule,
    ResultsMobileRoutingModule,
    SharedModule,
    MbButtonModule,
    StoreModule.forFeature('results', fromResults.reducers),
    EffectsModule.forFeature([ResultsEffecs]),
    FormsModule,
    AmRewardsPricingModule,
    AmSliderPointsModule,
  ],
  providers: [HotelsService, CurrencyPipe, CheckPipe],
})
export class ResultsMobileModule {}
